/**
 * 下载后端返回的文件流
 * @param res 文件流
 */

import { Modal } from 'view-design'

export default res => {
  try {
    if (res.data.type === 'application/json') {
      const fileReader = new FileReader()
      fileReader.readAsText(res.data, 'utf-8')
      fileReader.onload = function () {
        const result = JSON.parse(fileReader.result) || {}
        if (result.code == 1 || result.code == 500) {
          Modal.error({
            title: '提示',
            content: result.message,
          })
        } 
      }
      return
    }
    const blob = new Blob([res.data])
    let disposition = decodeURI(res.headers['content-disposition'])
    // 从响应头中获取文件名称
    let fileName = ''
    // 从响应头中获取文件名称
    if (disposition.indexOf('filename*=') > 0) {
      fileName = disposition.substring(disposition.indexOf('filename*=') + 17, disposition.length)
    } else {
      fileName = disposition.substring(disposition.indexOf('fileName=') + 22, disposition.length)
    }
    let text = fileName
    if ('download' in document.createElement('a')) {
      // 非IE下载
      const elink = document.createElement('a')
      elink.download = text.substring(0, text.length)
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName)
    }
  } catch (err) {
    Modal.error({
      title: '提示',
      content: '系统错误。请重试',
    })
  }
}
